import classNames from 'classnames';
import { ParamountPlusLogo, PlutoTVLogo } from '../assets';
import './Logo.scss';

export interface LogoProps {
  brand?: 'pplus' | 'pluto';
  size?: 'small' | 'large';
  className?: string;
  label?: string;
  href?: string;
  onClick?: React.MouseEventHandler<Element>;
  linkComponent?: React.ElementType;
}

const LOGO_BY_BRAND = {
  pplus: ParamountPlusLogo,
  pluto: PlutoTVLogo,
};

/**
 * Nav Item Logo
 * @param brand - sets brand pluto or pplus
 * @param size - sets size small or large
 * @param className - optional class
 * @param label - aria label
 * @param href - URL for the logo link
 * @param onClick - click handler
 * @param linkComponent - Custom component to render the logo wrapper instead of a `<div>` (e.g. Next.js Link). Must accept `href` as a prop.
 */
export const Logo: React.FC<LogoProps> = ({
  className = '',
  brand = 'pplus',
  size = 'large',
  label,
  href,
  onClick,
  linkComponent,
}) => {
  const LogoIcon = LOGO_BY_BRAND[brand];
  const Wrapper = href ? linkComponent || 'a' : 'div';
  return (
    <Wrapper
      href={href}
      onClick={onClick}
      aria-hidden={Wrapper === 'div'}
      aria-label={label}
      className={classNames(
        'vds-nav-logo',
        `vds-nav-logo--${size}`,
        `vds-nav-logo--${brand}`,
        className,
      )}>
      <LogoIcon />
    </Wrapper>
  );
};
